import { render, staticRenderFns } from "./ExamHistoryDetail.vue?vue&type=template&id=5889ec9c&scoped=true"
import script from "./ExamHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ExamHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamHistoryDetail.vue?vue&type=style&index=0&id=5889ec9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889ec9c",
  null
  
)

export default component.exports